import { WorkOverview } from '@/components/Domains/Works/components/WorkSingle'
import { BreadCrumbs } from '@/components/UIParts/Breadcrumbs'
import { Heading } from '@/components/UIParts/Heading/index'

import { GridSection } from '../../_Utils/GridSection'
import type { GetStaticPropsResult } from './_hook'

type Props = GetStaticPropsResult

export const WorkView = (props: Props) => {
  return (
    <GridSection className="relative pb-24 pt-16 md:pb-[15.875rem] md:pt-[7.375rem]">
      <div className="container">
        <BreadCrumbs
          lists={[
            {
              label: '実績一覧',
              href: '/works',
            },
            {
              label: `${props.work.client_name}様`,
            },
          ]}
          className="mb-14 md:mb-20"
        />
        <Heading main="Works" sub="実績 詳細" className="mb-6 md:mb-10" />

        <WorkOverview {...props} />
      </div>
    </GridSection>
  )
}
